module.exports = __webpack_public_path__ + "static/4099720f.pic.png";